import { render, staticRenderFns } from "./Sims.vue?vue&type=template&id=5b80dd06&"
import script from "./Sims.vue?vue&type=script&lang=ts&"
export * from "./Sims.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports